module.exports = __webpack_public_path__ + "img/ai.a2c78442.svg";